module.exports = __webpack_public_path__ + "img/logo.370d7d2a.png";